import { useNavigate, useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";

// Central list of primary in-page sections (used by nav + footer)
export const SECTIONS = [
  { id: "features", label: "Features" },
  { id: "how-it-works", label: "How It Works" },
  { id: "showcase", label: "Product" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
];

export const usePageNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lenis = useLenis();

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const goToSection = (id) => {
    if (location.pathname === "/") {
      scrollToId(id);
    } else {
      navigate("/");
      setTimeout(() => scrollToId(id), 320);
    }
  };

  const goTop = () => {
    if (lenis) lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return { goToSection, goTop };
};
